import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useSiteContent } from "@/lib/useSiteContent";

const links = [
  { label: "Who We Are", href: "#who-we-are" },
  { label: "Opportunities", href: "#opportunities" },
  { label: "Why Dubai", href: "#why-dubai" },
  { label: "Philosophy", href: "#philosophy" },
  { label: "Process", href: "#process" },
  { label: "Trending", href: "#trending" },
  { label: "Insights", href: "#insights" },
];

export default function Navbar() {
  const nav = useSiteContent().navbar;
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "nav-glass py-3" : "py-6 bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-brand"
          className={`font-serif-luxe text-xl md:text-2xl tracking-tight ${
            scrolled ? "text-[#1D1D1F]" : "text-white"
          }`}
        >
          {nav.brand_prefix} <span className="text-[#B68D40]">{nav.brand_suffix}</span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`link-gold text-[0.82rem] tracking-[0.14em] uppercase ${
                scrolled ? "text-[#1D1D1F]" : "text-white/90"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a href="#contact" data-testid="nav-cta" className="btn-luxe">
            {nav.cta_label}
          </a>
        </div>

        <button
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((s) => !s)}
          className={`lg:hidden ${scrolled ? "text-[#1D1D1F]" : "text-white"}`}
        >
          {open ? <X strokeWidth={1.4} /> : <Menu strokeWidth={1.4} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden nav-glass border-t border-black/10 mt-3"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[#1D1D1F] text-sm tracking-[0.14em] uppercase"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="btn-luxe mt-4 self-start"
            >
              {nav.cta_label}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
